// src/pages/DashboardPage.tsx
import React from 'react';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import AdminPanel from '../components/AdminPanel';

const DashboardPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-3xl font-bold">Dashboard</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <AnalyticsDashboard />
        <AdminPanel />
      </div>
    </div>
  );
};

export default DashboardPage;